<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 1" :ripple="true"> مشاهده QR </v-tab>

            <v-tab :ripple="true"> پیش نمایش </v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <div class="d-flex flex-column justify-center align-center">
                <qr-maker :loading="loading" />
                <div class="rowinfo">
                  <v-btn class="btn-download" @click="showDialog = true">
                    <v-icon>mdi-progress-download</v-icon>
                    {{ $t("download_qr") }}                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-download`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="دانلود کیوآر"
                  />
                </div>
              </div>
            </v-tab-item>

            <v-tab-item>
              <gallery-mobile v-model="cardTexts" />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات گالری pdf</p>
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    label="نام گالری شما"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="نام گالری"
                  />
                </div>
                
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="col-md-12 mt-4">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6=2"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2">
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>


        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker.vue";
import GalleryMobile from "@/view/pages/otherQrTypes/pdfGallery/components/galleryMobile.vue";
import ListExpansion from "@/view/content/fragments/listExpansion.vue";
import NextBtn from "@/view/content/fragments/nextBtn.vue";
import DownloadFileWithApi from "@/view/pages/qrland/downloadFileWithApi.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { Bus } from "@/main";

export default {
  name: "pdfGalleryModel",

  components: {
    QrCodeMake,
    DownloadFileWithApi,
    NextBtn,
    ListExpansion,
    GalleryMobile,
    QrMaker,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "pdfGallery",
      e6: 1,
      qrShow: 1,
      domainId: null,
      info: null,
      createdDomain: null,
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: false,
      loading: false,
      errors: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      cardTexts: {
        visitName: "گالری pdf",

        pallete: {
          headColor: "linear-gradient(to bottom,#F7548AFF, #1A3870)",
          bodyColor: "linear-gradient(to bottom, #FFFFFF, #F1DFFBC4)",
          textColor: "#200101",
          borderColor: "#e2e8f0",
        },
        extraFields: [
          {
            icon: "mdi-information-outline",
            name: "راهنمای استفاده",
            value:
              "برای مشاهده، یا دانلود هر یک از فایل‌های PDF، لطفاً روی دکمه آن‌ها کلیک کنید.",
          },
        ],
        pdf: [
          {
            name: "گالری پروپزال‌های کیوآرلند",
            images: [
              {
                title: "پروپزال معرفی محصول",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description:
                  "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
                selected: true,
              },
              {
                title: "پروپزال کارت ویزیت الکترونیکی",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description:
                  "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
                selected: true,
              },
            ],
          },
        ],
        photo: {
          profile: "https://cdn.terminalads.com/upload/64b11ae97aae0.webp",
          transition: "scale",
          hasWelcome: false,
          headBackground: "https://cdn.terminalads.com/upload/67af0711b00c2.webp",
          showWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        organizationName: "ترمینال تبلیغات",
        subtitle: "در کمتر از چند دقیقه سازمان خودرا به مخاطب معرفی کنید!",
        website: "www.core.terminalads.com",
        baseInfo: {
          sectionColor: {
            backGround: "linear-gradient(to right, #ffffff, #F0F4F8)",
            text: "#1E293B",
          },
          slider: false,
          grid: false,
        },
        socialMedia: {},
        pdfSelector: {
          title: "لیست اسناد و فایل‌ها",
          description: "فایل مورد نظر خود را از لیست زیر انتخاب کنید:",
          sectionColor: {
            backGround: "#FFFFFF",
            text: "#333333",
          },
          slider: false,
          layout: "list",
        },
      },
      specialInfo: [
        {
          name: "baseInfo",
          value: "",
          title: "اطلاعات",
          icon: "account-outline",
        },
        {
          name: "imageUploader",
          value: "",
          title: "آپلود لوگو",
          icon: "image",
          model: "photo",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "افزودن گالری پی دی اف ",
          icon: "file",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
        },
      ],
      qrSvgDataUrl: "",
    };
  },
  computed: {
    defaultProfileImage() {
      return "https://cdn.terminalads.com/upload/64b11ae97aae0.webp";
    },
    defaultWebsite() {
      return this.$coreqrApi || "https://qr.terminalads.com";
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
    imageUrl_1() {
      return this.$cdnUrl + "/upload/6485f5712528f.webp";
    },
    imageUrl_2() {
      return this.$cdnUrl + "/upload/6485f56fe93f6.webp";
    },
    imageUrl_3() {
      return this.$cdnUrl + "/upload/6485f57221bc9.webp";
    },
    imageUrl_4() {
      return this.$cdnUrl + "/upload/6486cda4341fc.webp";
    },
    imageUrl_5() {
      return this.$cdnUrl + "/upload/6486cac9e99e1.webp";
    },
    imageUrl_6() {
      return this.$cdnUrl + "/upload/6486cf4c71122.webp";
    },
    imageUrl_7() {
      return this.$cdnUrl + "/upload/6486d1cad1870.webp";
    },
    imageUrl_8() {
      return this.$cdnUrl + "/upload/6487037d8ea38.webp";
    },
    imageUrl_9() {
      return this.$cdnUrl + "/upload/648703f54b008.webp";
    },
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = "fa";
    this.$i18n.locale = savedLanguage;

    this.cardTexts.photo.profile =
      "https://cdn.terminalads.com/upload/64b11ae97aae0.webp";
    this.cardTexts.website = this.$coreqrApi;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });
  },

  methods: {
    markQr(final = false) {
     
      this.loading = true;
      let obj = {
        type: "pdfGallery",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
            };
      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
          qr: obj,
          type: "pdfGallery",
          title: this.cardTexts.visitName,
        })
        .then(({ data }) => {
          this.loading = false;
          this.info = data.data;
          this.$toast.success("مدل گالری pdf شما با موفقیت ساخته شد.");
          this.qrShow = 0;
          if(final)
            this.$router.replace({ name: "modelsList" });
        })
        .catch((error) => {
          const response = error.response;
          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
